<template>
 <el-button type="primary" @click="doNext">废弃</el-button>
</template>

<script>
import { AdultNext } from '../status.js'
export default {
  props: {
    order: {
      type: Object,
      required: true
    }
    // status: {
    //   type: String,
    //   required: true
    // }
  },
  data () {
    return {

    }
  },
  methods: {
    doNext () {
      this.$emit('doNext')
    },
    next () {
      let data = {
        orderIds: [this.order.id],
        action: 'COMPLETED_ORDER_RESET' }
      data.orderStatusDetail = {
        orderStatusResult: 'ABANDON_WAITING_FUTURE_ACTION'
      }

      return AdultNext.call(this, data)
    }
  }
}
</script>

<style>

</style>
